export interface IHistogeneticsHighResTT {
    id: number,
    type: string,
    donorAlias: string,
    donorFirstName: string,
    donorLastName: string,
    recipientAlias: string,
    recipientFirstName: string,
    recipientLastName: string,
    uploadDate: string
}
